'use strict';

$(function () {

	$(document).pjax("#modal-pjax a", {
		"push": false,
		"replace": false,
		"timeout": 2000,
		"scrollTo": false,
		"container": "#modal-pjax"
	});
	$(document).off("submit", "#modal-pjax form[data-pjax]").on("submit", "#modal-pjax form[data-pjax]", function (event) {
		jQuery.pjax.submit(event, {
			"push": false,
			"replace": false,
			"timeout": 2000,
			"scrollTo": false,
			"container": "#modal-pjax"
		});
	});

	window.sfiles = [];

	$('body')
		.on('click', '#gag .vendor', function() {
			$('#gag').remove();
		})
		.on("click", '.hamburger', function () {
			$('body').toggleClass('menu-open');
			$(this).fadeIn();
			/*}).on('click', '.pagination a', function () {
					//$('#winners-grid').css('opacity', .4);
					$('html, body').animate({ scrollTop: $('#winners').offset().top }, 500);*/
		})
		.on('click', '[data-modal]:not([disabled])', function () {
			// document.body.scrollTop = 0;
			// document.documentElement.scrollTop = 0;
			$('#modal-pjax').load($(this).data('modal'), function () {
				$('#modal-pjax').focus();
			});
			$('body').addClass('modal-open').removeClass('menu-open');
		})
		.on('click', '.close', function () {  // , #overlay
			$('body').removeClass('modal-open').removeClass('menu-open');
			// Контент убираем после fade-out оболочки (500ms), чтобы карточка
			// гасла вместе с оверлеем. Если модалку открыли повторно раньше —
			// не чистим: load() сам заменит содержимое.
			setTimeout(function () {
				if (!$('body').hasClass('modal-open')) {
					$('#modal-pjax > *').remove();
				}
			}, 500);
			// mahist = document.getElementById('profile');
			// if(mahist) { $.pjax.reload({container: '#profile', async: false}); }
		})

		.on('click', '[data-scroll]', function () {
			$('body').removeClass('modal-open').removeClass('menu-open');
			let to = $(this).data('scroll');
			$('html, body').animate({ scrollTop: $(to).offset().top }, 500);
		})

		// REGISTER FORM
		.on('submit', '#register-form', function () {
			$('#register-form button').prop('disabled', true);
		})

		// CONTACT FORM
		.on('submit', '#contact-form', function () {
			$('#contact-form button').prop('disabled', true);
		})

		// STEP-FOUR FORM
		.on('submit', '#step-four-form', function () {
			$('#step-four-form button').prop('disabled', true);
		})

		// WINNERS
		.on('click', '#winner-form [data-show]', function (e) {
			e.preventDefault();
			$('#winner-form').prop('action', '/?show=' + $(this).data('show'));
			$('#winner-form').submit();
			return false;
		})

		// SECRET BUYER pictures upload
		.on('change', '#steptwoform-imagefiles', function (e) {
			$('.field-steptwoform-imagefiles').removeClass('has-error');
			$('.help-block-error').text('');
			var files = document.querySelector('input[type=file]').files;

			function readAndPreview(file, i) {
				//console.log(file);
				var reader = new FileReader();
				reader.addEventListener("load", function () {
					sfiles.push({
						name: file.name,
						base: this.result
					});
					$('#preview').append('<div class="files" data-name="' + file.name + '" style="background-image: url(' + this.result + ')"><span data-order="' + i + '"></span></div>');
				}, false);
				reader.readAsDataURL(file);
			}

			if (files) {
				[].forEach.call(files, readAndPreview);
			}
		})

		.on('click', '#preview span', function (e) {
			$('.field-steptwoform-imagefiles').removeClass('has-error');
			$('.help-block-error').text('');
			let parent = $(this).parent();
			let nm = $(parent).data('name');
			$(parent).remove();
			sfiles.forEach(function (e, i) {
				if (e.name === nm) {
					return sfiles.splice(i, 1);
				}
			});
		})

		.on('submit', '#files-form', function (e) {
      //console.log('submit');
			var names = [];
      let btn = $(this).find('[type=submit]');
			var formData = new FormData();
			$(".files").each(function (i) {
				names.push($(this).data('name'));
				formData.append('StepTwoForm[picture][]', new Blob([$(this).attr('style')]), $(this).data('name'));
			}).promise().done(function () {
				var unique = names.filter((v, i, a) => a.indexOf(v) === i);
				//console.log(names, unique);
				if (names.length < 3) {
					$('.field-steptwoform-imagefiles').addClass('has-error');
					$('.help-block-error').text('Ви повинні завантажити принаймні 3 файли');
				}
				else if (names.length > 5) {
					$('.field-steptwoform-imagefiles').addClass('has-error');
					$('.help-block-error').text('Ви не можете завантажувати більше 5-ти файлiв');
				}
				else if (names.length !== unique.length) {
					$('.field-steptwoform-imagefiles').addClass('has-error');
					$('.help-block-error').text('Схоже, ви намагаєтеся завантажити однакові файли');
				} else {
          //console.log('ajax');
					$.ajax({
						//url: 'http://example.com/script.php',
						data: formData,
						enctype: 'multipart/form-data',
						processData: false,
						contentType: false,
						type: 'POST',
						success: function (data) {
							$('#content .container').html(data);
							//console.log(data);
						}
					});
					$('#steptwoform-imagefiles').val('');
					$(btn).prop('disabled', true).text('').addClass('spinner');
				}

			});

			return false;

		})

		.on("submit", "#page.testing form", function (e) {
      console.log('click');
      let act = $(this).attr('action');
			e.preventDefault();
			$.ajax({
				type: "POST",
				url: act, // '/testing'
				data: $("#page.testing form").serialize(),
				success: function (data) {
					console.log('data', data);
          let o = JSON.parse(data);
					$.each(o.answers, function(k, value) {
						if(value) {
							$('#page.testing form label').eq(k).find('.label').css('background-color', 'green').css('color', 'white');
						} else {
							$('#page.testing form label').eq(k).find('.label').css('background-color', 'red').css('color', 'white');
						}
					});
          if(o.finished) {
            $('#page.testing form input').prop('disabled', true);
            $('#modal-pjax').html(
              '<div class="modal-content score"><div class="close"><svg width="28" height="27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.657 5.657l2.121 2.121L8.343 21.213l-2.121-2.121L19.657 5.657z" fill="#fff"/><path d="M21.778 19.092l-2.121 2.121L6.222 7.778l2.121-2.121 13.435 13.435z" fill="#fff"/></svg></div><div class="text"><p>Ви пройшли тест з результатом ' + o.score + ' правильних відповідей з 10</p><div class="score-buttons"><a class="retry" href="' + act + '"><span>Пройти ще раз</span></a><a class="study-link" href="/study"><span>Навчання</span></a></div></div></div>'
            );
            $('body').addClass('modal-open').removeClass('menu-open');
          } else {
  					let a = $('#page.testing form button').parent();
					  a.html('<a class="dali" href="' + act + '"><span>ДАЛІ</span></a>');
					  $('#page.testing form input').prop('disabled', true);
          }
				},
        error: function($data) {

          console.log('error', $data);
        }
			});
			return false;
		});
	//$('.page-content').mCustomScrollbar();

	lazyload();

});


//   let obraz = [
//     [2, 'Ласкаво просимо до світу рішень від Syngenta!'],
//     [3, 'Час рости разом із Syngenta'],
//     [5, 'Нові тести вже чекають на тебе!'],
//     [5, 'Час дізнатися щось нове! Ласкаво просимо!'],
//     [5, 'Вже придумали, як використаєте нові знання?'],
//     [6, 'Воу, нуль помилок! Та ви справжній геній! Готові до останнього запитання?'], // 5
//     [6, 'Ви виконали вже більше тестів, ніж 83% користувачів. Так тримати!'],
//     [8, 'Помилки нас вчать! Вперед!'],
//     [8, 'Спробуймо ще раз, ви вже близько!'],
//     [8, 'Не переймайтеся, у вас усе вийде!'],
//     [1, '«Той, хто продовжує вчитися – лишається молодим!» (Генрі Форд)'], // 10
//     [1, 'Ви на фінішній прямій! Залишилось лише кілька тестів!'],
//     [4, 'Всі тести пройдено. Ви – суперзірка!'],
//   ];

//   function singMichael($i) {
//     $('#obraz .michael').css('background-image', 'url(/img/obraz/' + obraz[$i][0] + '.png)');
//     $('#obraz .bubble').html(obraz[$i][1] + '<div class="times">×</div>');
//     $('#obraz').addClass('active');
//     $('#obraz .times').on('click', function() {
//       $('#obraz').removeClass('active');
//     });
//     setTimeout(() => {
//       $('#obraz').removeClass('active');
//     }, 20000);
//   }